import { MeteringObservedState } from '../types/metering-observed-state.type';

/**
 * One observe write: clean observation or incomplete-read bump.
 */
export class WriteMeteringObservationItemDto {
  tenantId!: number;
  /** When true, bump consecutiveIncompleteReads instead of writing state. */
  incomplete?: boolean;
  observedHash?: string | null;
  observedState?: MeteringObservedState | null;
}
